/**
 * @generated SignedSource<<e12f42bf2fd430631c15e6be521ffe1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RouteConfig_PasswordResetPage_Query$variables = {
  customLandingHostname: string;
};
export type RouteConfig_PasswordResetPage_Query$data = {
  readonly viewer: {
    readonly customPortal: {
      readonly " $fragmentSpreads": FragmentRefs<"PasswordResetPage_customPortal">;
    } | null;
  };
};
export type RouteConfig_PasswordResetPage_Query = {
  response: RouteConfig_PasswordResetPage_Query$data;
  variables: RouteConfig_PasswordResetPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customLandingHostname"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "customLandingHostname",
    "variableName": "customLandingHostname"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RouteConfig_PasswordResetPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "CustomPortalNode",
            "kind": "LinkedField",
            "name": "customPortal",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PasswordResetPage_customPortal"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RouteConfig_PasswordResetPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "CustomPortalNode",
            "kind": "LinkedField",
            "name": "customPortal",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logoImageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "footerImageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headerFontColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "faviconUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pageTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contactEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4b44156488cc903c9bb152d2bd51bc29",
    "id": null,
    "metadata": {},
    "name": "RouteConfig_PasswordResetPage_Query",
    "operationKind": "query",
    "text": "query RouteConfig_PasswordResetPage_Query(\n  $customLandingHostname: String!\n) {\n  viewer {\n    customPortal(customLandingHostname: $customLandingHostname) {\n      ...PasswordResetPage_customPortal\n      id\n    }\n  }\n}\n\nfragment PasswordResetPage_customPortal on CustomPortalNode {\n  logoImageUrl\n  footerImageUrl\n  customColor\n  headerFontColor\n  faviconUrl\n  pageTitle\n  contactEmail\n}\n"
  }
};
})();

(node as any).hash = "b6a36c3412bbc3f9cc574246e7d95fbf";

export default node;
